/**
 * Stripe's embedded Checkout, mounted in place with the session's client
 * secret. Stripe draws the form; Stripe sends the person back to /credits
 * afterwards, and the webhook applies the purchase.
 */
import { useEffect, useRef, useState } from 'react';
import type { LoadStripe } from '../stripe.js';
import { IconButton, Note } from '../ui/index.js';

export function CheckoutPanel({ clientSecret, publishableKey, loadStripe, title, onClose }: { clientSecret: string; publishableKey: string; loadStripe: LoadStripe; title: string; onClose: () => void }) {
  const host = useRef<HTMLDivElement>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let destroyed = false; let checkout: { destroy(): void } | null = null;
    void (async () => {
      const stripe = await loadStripe(publishableKey);
      if (destroyed) return;
      if (!stripe) { setError('Stripe could not be loaded. Check your connection and try again.'); return; }
      try { const c = await stripe.initEmbeddedCheckout({ clientSecret }); if (destroyed) { c.destroy(); return; } checkout = c; if (host.current) c.mount(host.current); }
      catch (e) { setError(e instanceof Error ? e.message : String(e)); }
    })();
    return () => { destroyed = true; checkout?.destroy(); };
  }, [clientSecret, publishableKey, loadStripe]);
  return (
    <section className="rv-checkout" aria-label={title}>
      <header className="rv-row rv-row--between"><h2 className="rv-heading">{title}</h2><IconButton icon="x" label="Close checkout" onClick={onClose} /></header>
      {error ? <Note tone="danger">{error}</Note> : null}
      <div ref={host} className="rv-checkout__frame" />
    </section>
  );
}
